module.exports = __webpack_public_path__ + "fonts/Decimal-Bold.7eb8a31.woff";